export const issueVouchers = {
  title: 'Phiếu xuất',
  titles: {
    create: 'Thêm phiếu xuất',
    edit: 'Sửa phiếu xuất',
    detail: 'Chi tiết phiếu xuất',
    list: 'Danh sách phiếu xuất',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    linkage: 'Kho, khách hàng & người liên quan',
    note: 'Ghi chú',
    detail: 'Thông tin phiếu',
  },
  fields: {
    code: 'Mã phiếu',
    warehouse: 'Kho',
    customer: 'Khách hàng',
    createdBy: 'Người tạo',
    deliverer: 'Người giao',
    confirmer: 'Người xác nhận',
    status: 'Trạng thái',
    batches: 'Lô hàng',
    note: 'Ghi chú',
    actions: 'Thao tác',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
  },
  statusValues: {
    PENDING: 'Chờ xử lý',
    IN_PROGRESS: 'Đang xử lý',
    DELIVERED: 'Đã giao',
    CANCELLED: 'Đã hủy',
  },
  actions: {
    confirmProgress: 'Xác nhận tiến trình',
    confirmDelivered: 'Xác nhận đã giao',
  },
  messages: {
    noData: 'Không có dữ liệu',
  },
  filter: {
    placeholder: 'Tìm theo mã phiếu, kho, khách...',
  },
  validation: {
    atLeastOneBatch: 'Chọn ít nhất một lô hàng',
  },
}
